<template>
  <div
    ref="cardRef"
    class="card bg-base-100 h-fit shadow-sm"
    :class="twMerge((!isOnline || uninstalled) && 'opacity-60')"
  >
    <div class="card-body text-base-content/80">
      <div class="text-base-content flex items-baseline justify-between">
        <h2 class="card-title line-clamp-1 break-all">
          {{ props.computerName }}
        </h2>
        <span class="relative flex size-3">
          <template v-if="isOnline && !uninstalled">
            <span
              class="bg-success absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
            ></span>
            <span
              :title="'Online'"
              class="bg-success relative inline-flex size-3 rounded-full"
            ></span>
          </template>
          <template v-else-if="!isOnline && !uninstalled">
            <span
              class="bg-error absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
            ></span>
            <span
              :title="'Offline'"
              class="bg-error relative inline-flex size-3 rounded-full"
            ></span>
          </template>
          <i
            v-else-if="uninstalled"
            class="fa-solid fa-link-slash"
            :title="'Uninstalled'"
          ></i>
        </span>
      </div>
      <div class="flex items-baseline gap-1 truncate text-sm italic">
        <span
          :title="dayjs(props.lastConnection).format('YYYY/MM/DD HH:mm:ss')"
        >
          {{ dayjs(props.lastConnection).fromNow() }}
        </span>
      </div>
      <div class="flex items-baseline gap-2 truncate">
        <i class="fa-brands fa-windows text-base-content/50"></i>
        <span
          :class="
            props.os.length >= 30
              ? 'tracking-tighter'
              : props.os.length >= 24
                ? 'tracking-tight'
                : props.os.length >= 18
                  ? 'tracking-normal'
                  : 'tracking-wide'
          "
          v-if="props.os"
        >
          {{ props.os }}
        </span>
        <span v-else class="text-base-content/20 italic"> N/A </span>
      </div>
      <div class="flex items-baseline gap-2 truncate">
        <i class="fa-solid fa-wifi text-base-content/60"></i>
        <span v-if="props.ip">
          {{ props.ip }}
          <span v-if="props.country && hasFlag(props.country)" class="ms-1">
            {{ getUnicodeFlagIcon(props.country) }}
          </span>
        </span>
        <span v-else class="text-base-content/20 italic"> N/A </span>
      </div>
      <div class="flex items-baseline gap-2 truncate">
        <i class="fa-solid fa-clock text-base-content/50"></i>
        <span> {{ dayjs(props.lastConnection).fromNow() }} </span>
      </div>
      <div class="flex items-baseline gap-2 truncate">
        <i class="fa-solid fa-code-branch text-base-content/50"></i>
        <span v-if="props.version"> {{ props.version }} </span>
        <span v-else class="text-base-content/20 italic"> N/A </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { hasFlag } from "country-flag-icons";
import getUnicodeFlagIcon from "country-flag-icons/unicode";
import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";

const props = defineProps<{
  isOnline?: boolean;
  computerName?: string;
  country?: string;
  os?: string;
  cpu?: string;
  ip?: string;
  lastConnection?: Date | number;
  uninstalled?: boolean;
  version?: string;
}>();
</script>
